module.exports = __webpack_public_path__ + "static/img/ce-1.a5644cb.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/image/ce-1.jpg
 ** module id = 572
 ** module chunks = 2
 **/